// src/components/dashboard/DashboardCard.js
import React from 'react';
import styled from 'styled-components';
import { FaExternalLinkAlt, FaSpinner } from 'react-icons/fa';
import { Link } from 'react-router-dom';

const Card = styled.div`
  background-color: ${props => props.theme.colors.surface};
  border-radius: ${props => props.theme.borderRadius};
  padding: ${props => props.theme.spacing(3)};
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  height: 100%;
  display: flex;
  flex-direction: column;
`;

const CardHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: ${props => props.theme.spacing(2)};
  padding-bottom: ${props => props.theme.spacing(2)};
  border-bottom: 1px solid ${props => props.theme.colors.inputGray}33;
`;

const CardTitle = styled.h3`
  margin: 0;
  color: ${props => props.theme.colors.primary};
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing(1)};
  font-size: ${props => props.theme.typography.fontSize.large};
`;

const ViewAllLink = styled(Link)`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing(0.5)};
  color: ${props => props.theme.colors.primary};
  font-size: ${props => props.theme.typography.fontSize.small};
  text-decoration: none;
  
  &:hover {
    text-decoration: underline;
  }
`;

const CardContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
`;

const LoadingContainer = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 150px;
  
  svg {
    font-size: 2rem;
    color: ${props => props.theme.colors.primary};
    animation: spin 1s linear infinite;
  }
  
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`;

const ErrorContainer = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 150px;
  color: ${props => props.theme.colors.error};
  text-align: center;
  padding: ${props => props.theme.spacing(2)};
`;

const DashboardCard = ({ 
  title, 
  icon, 
  viewAllLink, 
  loading = false, 
  error = null, 
  children 
}) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>
          {icon}
          {title}
        </CardTitle>
        
        {viewAllLink && (
          <ViewAllLink to={viewAllLink}>
            View All <FaExternalLinkAlt />
          </ViewAllLink>
        )}
      </CardHeader>
      
      <CardContent>
        {loading ? (
          <LoadingContainer>
            <FaSpinner />
          </LoadingContainer>
        ) : error ? (
          <ErrorContainer>
            {error}
          </ErrorContainer>
        ) : (
          children
        )}
      </CardContent>
    </Card>
  );
};

export default DashboardCard;